import {
  BlotterTableContext,
  useCurrenciesContext,
  useIntl,
  useSecuritiesContext,
  useStrategiesContext,
  useWLCustomerMarketAccountContext,
  useWLOrgConfigContext,
  useWLUserContext,
  useWLUsersContext,
  type BlotterTableContextProps,
} from '@talos/kyoko';
import { useMemo, type PropsWithChildren } from 'react';

export function BlotterTableContextProvider({ children }: PropsWithChildren) {
  const { strategiesByName } = useStrategiesContext();
  const { currenciesBySymbol } = useCurrenciesContext();
  const { securitiesBySymbol } = useSecuritiesContext();
  const { userByEmail, userByID } = useWLUsersContext();
  const { user: currentUser } = useWLUserContext();
  const { config: wlOrgConfig } = useWLOrgConfigContext();
  const { customerMarketAccountsBySourceAccountID } = useWLCustomerMarketAccountContext();
  const intl = useIntl();

  const context = useMemo<BlotterTableContextProps>(
    () => ({
      strategiesByName,
      currenciesBySymbol,
      securitiesBySymbol,
      customerMarketAccountsBySourceAccountID,
      userByEmail,
      userByID,
      currentUser,
      wlOrgConfig,
      intl,
      settings: {
        exportDatesRaw: undefined,
        // Because of how WL renders blotters (rendering them all in the background), the current banner doesn't work well. Try it out.
        // Can be enabled again when the WL app renders their blotters properly (one at a time).
        // There is a feature flag to connect here from wlOrgConfig.disableErrorBanner when the time comes.
        disableErrorBanner: true,
      },
    }),
    [
      currenciesBySymbol,
      currentUser,
      customerMarketAccountsBySourceAccountID,
      intl,
      securitiesBySymbol,
      strategiesByName,
      userByEmail,
      userByID,
      wlOrgConfig,
    ]
  );

  return <BlotterTableContext.Provider value={context}>{children}</BlotterTableContext.Provider>;
}
